import Resource, { createResourceHook } from '@tabeo/resync'
import api from '@tabeo/sharpei/utils/api'

class CollectionAccounts extends Resource {
  getInitialData() {
    return {
      items: null,
      totalCount: 0,
    }
  }

  getInitialConfig() {
    return {
      refreshInterval: 60 * 1000,
    }
  }

  async fetch(query) {
    const {
      activeTabs = [],
      searchQuery = query,
      limit = 10,
      offset = 0,
    } = this.params
    const pagination = `&limit=${limit}&offset=${offset}`

    const statuses = activeTabs.map(t => t.statuses.join(',')).join(',')

    const endpoint = searchQuery
      ? `consumer-search?subResource=loansSummary&condition=loansSummary.generalStatus:[${statuses}]&searchPhrase=${encodeURIComponent(
          searchQuery
        )}`
      : `consumers?order=userID:desc&subResource=loansSummary&condition=loansSummary.generalStatus:[${statuses}]`

    const {
      data: { consumers },
      totalCount,
    } = await api.get(`${endpoint}${pagination}`, {
      responseDataPath: 'data',
    })

    const data = {
      totalCount,
      items: consumers,
    }

    this.data = data

    return data
  }
}

export default CollectionAccounts
export const useCollectionAccounts = createResourceHook(CollectionAccounts)
